var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('redemption-page',{attrs:{"funds-selling-list":_vm.getFundsSellingList,"funds-in-redemption":_vm.getActiveRedemptionFundsId},on:{"download":_vm.download,"redemptionRequest":_vm.redemptionRequest,"download-file":_vm.downloadFile}})}
var staticRenderFns = []

export { render, staticRenderFns }